import {Injectable} from "@angular/core";
import {Rest, RestService} from "@abp/ng.core";
import {CompanyInfoDto} from "@proxy/AccountSettings/models";

@Injectable({
  providedIn: 'root',
})
export class AccountSettingsService {
  apiName = 'Default';

  constructor(private restService: RestService) {
  }

  updateCompanyInfo = (input: CompanyInfoDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, any>(
      {
        method: 'PUT',
        url: `/api/app/account-settings/set-company-info`,
        body: input,
      },
      {apiName: this.apiName, ...config}
    );
  fetchSettings = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, CompanyInfoDto>(
      {
        method: 'GET',
        url: '/api/app/account-settings/get-company-info',
      },
      {apiName: this.apiName, ...config}
    );
}
